import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("camper_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Los validadores del backend ya escriben su mensaje en castellano; pydantic le antepone «Value error, »
// (o «Assertion failed, »), que no se enseña. Varios mensajes van como frases: «A. B», sin repetir el punto.
const PREFIJO_PYDANTIC = /^(Value error|Assertion failed), /;
const frases = (msgs) => msgs.reduce((out, m) => (out ? `${out}${/[.!?]$/.test(out) ? "" : "."} ${m}` : m), "");

// Un `detail` con código (`{code, message}`, p. ej. el 409 de «incompleto» del registro) enseña su `message`.
export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Algo salió mal";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return frases(detail.map((d) => (d?.msg ? String(d.msg).replace(PREFIJO_PYDANTIC, "") : JSON.stringify(d))));
  if (typeof detail === "object")
    return typeof detail.message === "string" && detail.message ? detail.message : err?.message || "Algo salió mal";
  return String(detail);
}
